/** Gets route basename */
export function getRouteBasename(): string {
  return window.env?.basename.value ?? "";
}

export const getReCaptchaSitekey = (): string => {
  return window.env?.recaptchaSiteKey.value ?? "";
};

export const getDocNonce = (): string | undefined =>
  document.querySelector('meta[name="CSP-NONCE"]')?.getAttribute("content") ??
  undefined;

export const areAnalyticsUsed = (): boolean => window.analyticsUsed === true;

export const isGtmUsed = (): boolean => window.gtmUsed === true;

export * from "./accessControl";
export * from "./actions";
export * from "./baseRoute";
export * from "./featureFlags";
export * from "./files";
export * from "./forms";
export * from "./licenses";
export * from "./projects";
export * from "./purl";
export * from "./reports";
export * from "./scroll";
export * from "./toasts";
export * from "./urls";
export * from "./window";
